module.exports = __webpack_public_path__ + "img/coop.81d823ab.jpg";